import RuleService from '@/services/Rule.js';
import RuleSwitchOffModalContent from '@/ui/components/RuleSwitchOffModalContent.vue';
import RuleWithInactiveCampaignSwitchOnModalContent from '@/ui/components/RuleWithInactiveCampaignSwitchOnModalContent.vue';

export default {
  methods: {
    onChangeRuleStatus(rule, newStatus) {
      const { id } = rule;

      rule.active = newStatus;

      if (rule.hasOutputCampaign) {
        if (!newStatus && rule.campaign_status === 'active') {
          rule.active = !newStatus;

          this.$fullscreenModal.open(
            this,
            RuleSwitchOffModalContent,
            { rule },
            { classes: 'rule-switch-off-modal' },
          );
          return;
        }
        if (newStatus && rule.campaign_status === 'inactive') {
          rule.active = !newStatus;

          this.$fullscreenModal.open(
            this,
            RuleWithInactiveCampaignSwitchOnModalContent,
            { rule },
            { classes: 'rule-with-inactive-campaign-switch-on-modal' },
          );
          return;
        }
      }

      RuleService.changeStatus(id, newStatus)
        .then(resp => rule.updateWith(resp))
        .catch(err => {
          this.error(err);
          rule.active = !newStatus;
        });
    },
  },
};
